module.exports = __webpack_public_path__ + "media/location/header-df651f4e.jpg";